import { Box, useTheme } from '@mui/material'
import React from 'react'
import ErrorNotFoundIllustration from '../../img/error-not-found.svg?react'
import ErrorUnexpectedIllustration from '../../img/error-unexpected.svg?react'
import { RecoveryIllustrationVariant } from './RecoveryPage'

interface RecoveryIllustrationProps {
  variant: RecoveryIllustrationVariant
}

// Illustrations from unDraw (https://undraw.co) — free for commercial use, no attribution required.
export const RecoveryIllustration: React.FC<RecoveryIllustrationProps> = ({ variant }) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        width: '100%',
        color: theme.palette.primary.main,
        '--recovery-text': theme.palette.text.primary,
        '--recovery-surface': theme.palette.background.paper,
        '& svg': {
          display: 'block',
          width: '100%',
          height: 'auto',
        },
      }}
    >
      {variant === 'notFound' ? <ErrorNotFoundIllustration /> : <ErrorUnexpectedIllustration />}
    </Box>
  )
}
